import { getLastFourAccountNumber } from '../../common/utils/bankingUtils';
import { downloadPdf } from '../../common/utils/pdfUtils';
import { fetcher } from '../../http/Fetcher';

export type AccountVerificationLetterVariant = 'direct-deposit' | 'bill-pay';

const endpointByVariant: Record<
    AccountVerificationLetterVariant,
    (bankAccountId: string) => string
> = {
    'direct-deposit': (bankAccountId) =>
        `/api/bank-accounts/${bankAccountId}/direct-deposit-verification-letter`,
    'bill-pay': (bankAccountId) =>
        `/api/bank-accounts/${bankAccountId}/bill-pay-verification-letter`,
};

export const buildAccountVerificationLetterFilename = ({
    variant,
    accountNumberMasked,
}: {
    variant: AccountVerificationLetterVariant;
    accountNumberMasked: string;
}): string => {
    const label = getLastFourAccountNumber(accountNumberMasked);

    return `Fruitful_${variant}_account_verification_${label}.pdf`;
};

export const downloadAccountVerificationLetter = async ({
    variant,
    bankAccountId,
    accountNumberMasked,
}: {
    variant: AccountVerificationLetterVariant;
    bankAccountId: string;
    accountNumberMasked: string;
}): Promise<string> => {
    const response: { data: string } = await fetcher({
        method: 'GET',
        endpoint: endpointByVariant[variant](bankAccountId),
    });

    const filename = buildAccountVerificationLetterFilename({
        variant,
        accountNumberMasked,
    });

    return await downloadPdf(response, filename);
};
